"use strict";

var _classCallCheck = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _get = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _getPrototypeOf = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _assertThisInitialized = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PolygonRegion = void 0;

var Rect_1 = require("../../Core/Rect");

var Region_1 = require("../Region");

var AnchorsElement_1 = require("./AnchorsElement");

var DragElement_1 = require("./DragElement");

var TagsElement_1 = require("./TagsElement");
/**
 * The polygon-type region class.
 */


var PolygonRegion = /*#__PURE__*/function (_Region_1$Region) {
  _inherits(PolygonRegion, _Region_1$Region);

  /**
   * Creates new `PolygonRegion` object.
   * @param paper - The `Snap.Paper` object to draw on.
   * @param paperRect - The parent bounding box for created component.
   * @param regionData - The `RegionData` object shared across components. Used also for initial setup.
   * @param callbacks - The external callbacks collection.
   * @param id - The region `id` used to identify regions in `RegionsManager`.
   * @param tagsDescriptor - The descriptor of region tags.
   * @param tagsUpdateOptions - The drawing options for tags.
   */
  function PolygonRegion(paper) {
    var _this;

    var paperRect = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var regionData = arguments.length > 2 ? arguments[2] : undefined;
    var callbacks = arguments.length > 3 ? arguments[3] : undefined;
    var id = arguments.length > 4 ? arguments[4] : undefined;
    var tagsDescriptor = arguments.length > 5 ? arguments[5] : undefined;
    var tagsUpdateOptions = arguments.length > 6 ? arguments[6] : undefined;

    _classCallCheck(this, PolygonRegion);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PolygonRegion).call(this, paper, paperRect, regionData, Object.assign({}, callbacks), id, tagsDescriptor, tagsUpdateOptions));

    if (paperRect !== null) {
      _this.paperRects = {
        actual: new Rect_1.Rect(paperRect.width - regionData.width, paperRect.height - regionData.height),
        host: paperRect
      };
    }

    _this.buildOn(paper);

    var onChange = _this.callbacks.onChange;

    _this.callbacks.onChange = function (region, regionData) {
      _this.paperRects.actual.resize(_this.paperRects.host.width - regionData.width, _this.paperRects.host.height - regionData.height);

      for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        args[_key - 2] = arguments[_key];
      }

      onChange.apply(void 0, [_assertThisInitialized(_assertThisInitialized(_this)), regionData].concat(args));
    };

    return _this;
  }
  /**
   * Updates region tags.
   * @param tags - The new tags descriptor object.
   * @param options - The tags drawing options.
   */


  _createClass(PolygonRegion, [{
    key: "updateTags",
    value: function updateTags(tags, options) {
      _get(_getPrototypeOf(PolygonRegion.prototype), "updateTags", this).call(this, tags, options);

      this.tagsNode.updateTags(tags, options);
      this.node.select("title").node.innerHTML = tags !== null ? tags.toString() : "";
    }
    /**
     * Resizes the region to specified `width` and `height`.
     * @param width - The new region width.
     * @param height - The new region height.
     */

  }, {
    key: "resize",
    value: function resize(width, height) {
      this.paperRects.actual.resize(this.paperRects.host.width - width, this.paperRects.host.height - height);

      _get(_getPrototypeOf(PolygonRegion.prototype), "resize", this).call(this, width, height);
    }
    /**
     * Creates the UI of the region component.
     * @param paper - The `Snap.Paper` element to draw on.
     */

  }, {
    key: "buildOn",
    value: function buildOn(paper) {
      this.node = paper.g();
      this.node.addClass("regionStyle");
      this.node.addClass(this.styleID);
      this.dragNode = new DragElement_1.DragElement(paper, this.paperRects.actual, this.regionData, this.callbacks);
      this.tagsNode = new TagsElement_1.TagsElement(paper, this.paperRect, this.regionData, this.tags, this.styleID, this.styleSheet, this.tagsUpdateOptions);
      this.anchorNode = new AnchorsElement_1.AnchorsElement(paper, this.paperRect, this.regionData, this.callbacks);
      this.toolTip = Snap.parse("<title>".concat(this.tags !== null ? this.tags.toString() : "", "</title>"));
      this.node.append(this.toolTip);
      this.node.add(this.dragNode.node);
      this.node.add(this.tagsNode.node);
      this.node.add(this.anchorNode.node);
      this.UI.push(this.tagsNode, this.dragNode, this.anchorNode);
    }
  }]);

  return PolygonRegion;
}(Region_1.Region);

exports.PolygonRegion = PolygonRegion;